// src/components/ui/switch.jsx
import React, { forwardRef } from "react";

export const Switch = forwardRef(
  ({ className = "", checked, onCheckedChange, ...props }, ref) => {
    return (
      <button
        type="button"
        ref={ref}
        role="switch"
        aria-checked={checked}
        data-state={checked ? "checked" : "unchecked"}
        className={`relative inline-flex h-5 w-10 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 focus-visible:ring-offset-2 focus-visible:ring-offset-white disabled:cursor-not-allowed disabled:opacity-50 ${
          checked ? "bg-indigo-600" : "bg-gray-200"
        } ${className}`}
        onClick={() => onCheckedChange(!checked)}
        {...props}
      >
        <span
          data-state={checked ? "checked" : "unchecked"}
          className={`pointer-events-none block h-4 w-4 rounded-full bg-white shadow-lg ring-0 transition-transform ${
            checked ? "translate-x-5" : "translate-x-0"
          }`}
        />
      </button>
    );
  }
);

Switch.displayName = "Switch";
